import styled from "styled-components";

import { PrintStyleSheet } from "../seller/advert-seller-details/location/location.styles";

export const LeasingVehicleSummary = styled.section`
  button.atds-button {
    ${PrintStyleSheet}
  }
`;
